/* ==========================================================
   WM Value Props — wm-value-props.js
   Version: 1.0.0
   ========================================================== */

(function () {
  'use strict';

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target.dataset.sectionType === 'wm-value-props') {
      /* reinit if needed */
    }
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.target.dataset.sectionType === 'wm-value-props') {
      /* clean up if needed */
    }
  });

})();
